import React from 'react';

import { ProductDetail } from 'commons/types';
import { TableConfig } from 'commons/types/tableConfig.interface';
import { formatDate } from 'commons/utils/formatDate';

export const config: TableConfig = [
  {
    header: 'Bin',
    key: 'bin',
  },
  {
    header: 'Bin Type',
    key: 'bin_type',
  },
  {
    header: 'ED',
    element: (item: ProductDetail): React.ReactElement => {
      const date = formatDate(item.expiry_date);
      return <div>{date === 'Invalid DateTime' ? '-' : date}</div>;
    },
  },
  {
    header: 'QTY',
    key: 'quantity',
  },
];
